// extracted by mini-css-extract-plugin
export var statItem = "_fo-1";
export var statsRow = "_fo-0";